import { Icon } from "@legal-500/legal500-design-system";
import { languageName } from "../utils/languageName";
import styles from "./AutoTranslatedNotice.module.css";

type AutoTranslatedNoticeProps = {
  detectedLanguage: string | null | undefined;
  languageIso: string;
};

export function AutoTranslatedNotice({ detectedLanguage, languageIso }: AutoTranslatedNoticeProps) {
  if (!detectedLanguage || detectedLanguage === languageIso) return null;

  const [baseLanguage = detectedLanguage] = detectedLanguage.split("-");

  return (
    <div className={styles.notice} role="status">
      <span className={styles.icon} aria-hidden="true">
        <Icon icon="info" size="small" />
      </span>
      <p className={styles.message}>
        This content was auto-translated from {languageName(baseLanguage)}. The firm's original
        wording is in the source panel.
      </p>
    </div>
  );
}
